<ng-container *transloco="let t">
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button defaultHref="home"></ion-back-button>
            </ion-buttons>
            <ion-title>{{ t(title) }}</ion-title>
        </ion-toolbar>
    </ion-header>

    <ion-content>
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>
    </ion-content>
</ng-container>
